import React from "react";
import { motion } from "framer-motion";
import Logo from "../../assets/Logo.svg";

const LoadingPage = () => {
  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100">
      <div className="relative">
        {/* Spinning Circle */}
        <motion.div
          className="absolute inset-0 border-4 border-t-blue-500 border-r-transparent border-b-transparent border-l-transparent rounded-full w-32 h-32"
          animate={{ rotate: 360 }}
          transition={{
            duration: 1,
            repeat: Infinity,
            ease: "linear",
          }}
        />

        {/* Logo */}
        <img src={Logo} alt="Logo" className="w-24 h-24 object-contain" />
      </div>
    </div>
  );
};

export default LoadingPage;
